import { ApolloError } from "@apollo/client";
import { ErrorLink } from "@apollo/client/link/error";
import { formatUnknownError } from "../notifications/formatError";
import { getGlobalNotifier } from "../notifications/notifier";

export const makeErrorLink = (
  _callbacks?: Partial<{ graphQl: () => void; network: () => void }>,
) => {
  return new ErrorLink(({ graphQLErrors, networkError }) => {
    const apolloError = new ApolloError({ graphQLErrors, networkError });
    // Connection-loss noise is handled by the WS connection notifier in initApolloClient2.
    // Avoid spamming the user with near-duplicate messages like:
    // - "Socket closed"
    // - "WebSocket connection failed"
    const msg = apolloError.message ?? "";
    if (
      msg.includes("Socket closed") ||
      msg.includes("WebSocket connection failed") ||
      msg.includes("Connection closed")
    ) {
      return;
    }

    console.error(apolloError);

    // Avoid spamming on auth transitions (login redirects will handle this).
    if (apolloError.message.includes("Unauthorized")) {
      return;
    }

    const formatted = formatUnknownError(apolloError, {
      defaultMessage: "Request failed",
      keyPrefix: "api",
    });
    getGlobalNotifier().notify(formatted.level, formatted.message, {
      key: formatted.key ?? `api:${formatted.message}`,
      description: formatted.description,
    });
  });
};
